import { render, staticRenderFns } from "./mall-reward.vue?vue&type=template&id=de53196c&scoped=true&lang=pug&"
import script from "./mall-reward.vue?vue&type=script&lang=js&"
export * from "./mall-reward.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de53196c",
  null
  
)

export default component.exports